import LoaderContext from "Components/LoaderContext/LoaderContext";

const LoaderConsumer = LoaderContext.Consumer;

export default LoaderConsumer;
